import React from "react";
import { UseFormWatch } from "react-hook-form";
import _ from "lodash";

const useFieldsToHide = (
    watch: UseFormWatch<Compleo.IObject>,
    ready: boolean
) => {
    const [fieldsToHide, setFieldsToHide] = React.useState<string[]>([]);
    const allBranchs = watch("filters_allBranchs") === true;
    const allCustomers = watch("filters_allCustomers") === true;
    const defaultApplicationForm = watch("defaultApplicationForm");
    const useDefaultApplicationForm = defaultApplicationForm !== false;
    console.log("useDefaultApplicationForm", useDefaultApplicationForm);

    React.useEffect(() => {
        let newFieldsToHide = [...fieldsToHide];
        if (!ready) {
            return;
        }

        if (!allBranchs && newFieldsToHide.includes("filters_branchs")) {
            newFieldsToHide = newFieldsToHide.filter(
                (field) => field !== "filters_branchs"
            );
        }
        if (allBranchs && !newFieldsToHide.includes("filters_branchs")) {
            newFieldsToHide = [...newFieldsToHide, "filters_branchs"];
        }
        if (!allCustomers && newFieldsToHide.includes("filters_customers")) {
            newFieldsToHide = newFieldsToHide.filter(
                (field) => field !== "filters_customers"
            );
        }
        if (allCustomers && !fieldsToHide.includes("filters_customers")) {
            newFieldsToHide = [...newFieldsToHide, "filters_customers"];
        }
        if (
            useDefaultApplicationForm &&
            !newFieldsToHide.includes("applicationForm")
        ) {
            newFieldsToHide = [...newFieldsToHide, "applicationForm"];
        }
        if (
            !useDefaultApplicationForm &&
            newFieldsToHide.includes("applicationForm")
        ) {
            newFieldsToHide = newFieldsToHide.filter(
                (field) => field !== "applicationForm"
            );
        }

        setFieldsToHide(newFieldsToHide);
    }, [allBranchs, allCustomers, useDefaultApplicationForm, ready]);
    return { fieldsToHide };
};

export default useFieldsToHide;
